import { default as appliedFiltersInit } from "./applied-filters.js"
import { reInitAfterSearch as airportPickerReInitAfterSearch } from "./airport-picker.js"
import { loader } from "./popups.js";
import { getSearchBarOptions } from "./search-bar.js";
import { default as helpPinInit } from "./help-pin.js";
import { default as toggleBlockInit } from "./toggle-block.js";
import { currentTabSelection } from "./tabs-simple.js";
import { breakpoints } from "./utilities.js";
import { updateUrlSearchParams } from "./pickers-init.js";

// Search Results page and filters

// ajax request instance
let request = null;

// timeout instance
let timeout = null;

// time we should wait after no interactions with the dynamic form before submitting any request (ms)
const waitTime = 650;

const elements = {
	form: $('.js-dynamic-search'),

	checks: null,
	radios: null,
	clear: null,
	sort: null,
	prev: null,
	next: null,
	page: null,
	folksSelectorWrapper: null,
	where: null,
	when: null,
	duration: null,

	cache: function() {
		// Since the whole filters section is replaced on each ajax call, these selectors need to be refound each time too
		elements.checks = elements.form.find('input[type="checkbox"]').not('.js-dynamic-search-exclude');
		elements.radios = elements.form.find('input[type="radio"]');
		elements.clear = elements.form.find('.js-dynamic-search-clear');
		elements.sort = elements.form.find('.js-dynamic-search-sort');
		elements.prev = elements.form.find('.js-dynamic-search-prev');
		elements.next = elements.form.find('.js-dynamic-search-next');
		elements.page = elements.form.find('.js-dynamic-search-page');
		elements.where = elements.form.find('input[name="airport"]');
		elements.when = elements.form.find('input[name="departuredateuk"]');
		elements.duration = elements.form.find('input[name="nights"]');
	}
}

// facilitate the caching and setting of mustache templates / check whether all elements requried for dynamic search are present
const templates = {
	elements: {
		block: $('#searchBlock'),
		folk: $('#folkSelectorTemplate'),
		appliedFilters: $('#appliedFilters')
	},
	wrappers: {
		summary: $('.js-dynamic-search-replace-summary'),
		results: $('.js-dynamic-search-replace-results'),
		pager: $('.js-dynamic-search-replace-pager'),
		block: $('.js-dynamic-search-replace-block'),
		holiday: $('.js-dynamic-search-replace-holiday'),
		collection: $('.js-dynamic-search-replace-collection'),
		facilities: $('.js-dynamic-search-replace-facilities'),
		accommodation: $('.js-dynamic-search-replace-accommodation'),
		appliedFilters: $('.js-dynamic-search-replace-applied-filters')
	},
	set: function() {
		templates.elements.block = templates.elements.block.html();
		templates.elements.folk = templates.elements.folk.html();
		templates.elements.appliedFilters = templates.elements.appliedFilters.html();
	},
	check: function() {
		const els = [templates.elements.block, templates.elements.folk, templates.elements.appliedFilters]
		return els.every(element => element.length)
	}
}

const attachEvents = () => {
	elements.cache();

	elements.checks.on('change', submit);
	elements.radios.on('change', submit);
	elements.sort.on('change', submit);

	elements.clear.on('click', submit);
	elements.prev.on('click', submit);
	elements.next.on('click', submit);
	elements.page.on('click', submit);
}

// set base url / create url for request / update browser url
const urlCreate = function(e) {
	const base = window.location.pathname + '?';
	const target = e ? $(e.target) : false;
	let url;
	if (target && target.attr('href')) {
		url = target.attr('href');
	}
	else {
		url = base + elements.form.serialize();
	}

	return url;
}

// scroll to results
const scroll = function(mobileFiltersVisible) {
	if (templates.wrappers.block.offset().top === window.site.doc.scrollTop()) {
		return;
	}

	if (mobileFiltersVisible) {
		window.site.htmlbody.animate({ scrollTop: window.site.body.offset().top }, 500);
		return;
	}

	window.site.htmlbody.animate({ scrollTop: templates.wrappers.block.offset().top }, 500);
}

const submit = (e) => {
	// set and kill wait time for non form elements
	let _waitTime = waitTime;
	let alwaysScroll = false;

	if ($(e.target).attr('data-search-results-scroll')) {
		alwaysScroll = true;
	}

	if (!e || $(e.target).attr('href')) {
		// e can be false from forms.js/datepicker();
		_waitTime = 0;
	}

	if (timeout) {
		clearTimeout(timeout);
	}

	if (request !== null) {
		request.abort();
		request = null;
	}

	timeout = setTimeout(function() {
		const url = urlCreate(e);
		loader();

		request = $.ajax({
			url,
			dataType: 'html',
			success: function(response) {
				getSearchBarOptions();
				render(response, url)
			},
			error: function(e) {
				console.log('dynamic-search failure')
			},
			complete: function() {
				loader(true);
				request = null;
				timeout = null;

				const mobileFiltersHidden = window.site.win.width() > breakpoints.tabletLarge - 1;
				if (alwaysScroll) {
					scroll(!mobileFiltersHidden);
				}
			}
		});
	}, _waitTime);

	return false;
}

// render response from server
const render = function(response) {
	const $response = $(response);

	const searchResultsListId = '#search-list-tab';
	const searchResultsFiltersId = '#search-results-filters';
	const searchResultsSummaryClass = '.js-dynamic-search-replace-summary';

	const $searchResultsList = $response.find(searchResultsListId);
	const $searchResultsFilters = $response.find(searchResultsFiltersId);
	const repsonseHtml = $searchResultsFilters.html();
	const $summary = $response.find(searchResultsSummaryClass);

	//Remove these before firing html() to avoid orphaned event handlers
	elements.sort.off('change', submit);

	elements.clear.off('click', submit);
	elements.prev.off('click', submit);
	elements.next.off('click', submit);
	elements.page.off('click', submit);

	$(searchResultsListId).html($searchResultsList.html())
	$(searchResultsSummaryClass).html($summary.first().html());

	// The old way was to delete the filters and re-poulate it with html(), this leads to state issues with the checkboxes, a lot more JS processing to initialise the inputs on every update and race conditions with accommodation-only
	// This way is a start towards loading update over JSON rather than HTML blocks and when switched will require little changes
	// Loop over `response` data and look up the matching checkbox, then update the results value in place.
	const responseDataToStrings = (val) => {
		const text = val.innerText.replaceAll("\n", '').trim();
		const title = text.substr(0, text.indexOf(" ("));
		const total = parseInt(text.match(/\((.*)\)/)?.pop() || 0);
		const checked = $(val).find('input').is(':checked')

		return { text, title, total, checked }
	}

	$(repsonseHtml).find('#facilities-filters, #holiday-filters, #collection-filters').find('label').each(function(idx, val) {
		const { text, title, total, checked } = responseDataToStrings(val)

		const foundFilterItem = $('#facilities-filters, #holiday-filters, #collection-filters').find(`span:contains('${title}')`)
		foundFilterItem.text(text)
		foundFilterItem.prev('input').prop('disabled', total < 1)
		foundFilterItem.prev('input').prop('checked', checked)
	})

	$(repsonseHtml).find('#accomodation-filters').find('label').not(":first").each(function(idx, val) {
		const { text, title } = responseDataToStrings(val)

		const foundFilterItem = $('#accomodation-filters').find(`span:contains('${title}')`)
		foundFilterItem.text(text)
	})

	attachEvents()
	airportPickerReInitAfterSearch();
	helpPinInit();
	toggleBlockInit();
	getMapResults();
	updateUrlSearchParams()
}

const init = function() {
	if (!elements.form.length || !templates.check()) {
		return
	}

	templates.set();

	attachEvents()

	appliedFiltersInit();
	getMapResults();
}

function getMapResults() {
	let url = '/api/map/search?' + elements.form.serialize();
	const presetSearchParameters = $('.js-search-map-container').attr('data-map-node-preset-querystring');
	if (presetSearchParameters) {
		url += `&${presetSearchParameters}`;
	}

	return $.ajax({
		url,
		dataType: 'json',
		success: function(response) {
			document.getElementsByClassName('js-search-map-results').item(0).textContent = JSON.stringify(response);

			if (currentTabSelection === 'search-map-tab') {
				window.site.body.trigger({
					type: "resultsUpdate",
					tabTarget: "#search-map-tab"
				})
			}
		},
		error: function(event, request, settings) {
			alert('Sorry! Something went wrong when loading the map, please try refrshing the page.');
		}
	});
}

export default init;
export { submit, getMapResults }
